import * as React from "react";

import {Card} from "bloomer";
import styled from "react-emotion";
import {Redirect} from "react-router";
import {isLoggedIn} from "../../utils/auth";
import {FormContainer, Header, Switch} from "./Styles";
import Spacer from "../../elements/Spacer";
import SendGAWConversionEvent from "../../utils/SendGAWEvent";
import FBPixelPageView from "../../utils/FBPixelPageView";

const RegisteredPage = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 100%;
`;

const PageContent = styled(Card)`
  text-align: center;
  background: #ebf1f5;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  min-height: 200px;
`;

const SuccessMessage = styled("div")`
  margin: auto;
  text-align: center;
  font-size: 16px;
  width: 300px;
  padding-bottom: 10px;
`;

const GreenText = styled("span")`
  color: green;
`;

interface IRegisteredState {
    page: string;
}

class Registered extends React.Component<{}, IRegisteredState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            page: ""
        };
    }

    public componentDidMount() {
        SendGAWConversionEvent();
        FBPixelPageView();
    }

    public render() {
        return (
            <RegisteredPage>
                <PageContent>
                    {isLoggedIn() && <Redirect to="/models"/>}
                    {this.state.page === "login" && <Redirect to="/login"/>}
                    <Header>Sign Up</Header>
                    <Spacer/>
                    <FormContainer>
                        <SuccessMessage>
                            <GreenText>{"You have successfully signed up. Please "}</GreenText>
                            <Switch onClick={() => this.setState({page: "login"})}>Sign In</Switch>
                            <GreenText>{"."}</GreenText>
                        </SuccessMessage>
                    </FormContainer>
                </PageContent>
            </RegisteredPage>
        );
    }
}

export default Registered;


// WEBPACK FOOTER //
// ./src/routes/Login/Registered.tsx